import { render, staticRenderFns } from "./PhysicianCloningModal.vue?vue&type=template&id=1ea35901&scoped=true&"
import script from "./PhysicianCloningModal.vue?vue&type=script&lang=js&"
export * from "./PhysicianCloningModal.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianCloningModal.vue?vue&type=style&index=0&id=1ea35901&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea35901",
  null
  
)

component.options.__file = "PhysicianCloningModal.vue"
export default component.exports